import { render, staticRenderFns } from "./WidgetConfig.html?vue&type=template&id=7767f91e&scoped=true&external"
import script from "./WidgetConfig.ts?vue&type=script&lang=ts&external"
export * from "./WidgetConfig.ts?vue&type=script&lang=ts&external"
import style0 from "./WidgetConfig.css?vue&type=style&index=0&id=7767f91e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7767f91e",
  null
  
)

export default component.exports